import { Injectable } from '@angular/core';
import { AppConfig } from '../models/app.config';
import { LoggerOptions } from '../models/logger';

// Declare that the window object can have an appConfig property.
// This prevents some implicit any types.
declare global {
  interface Window {
    appConfig: AppConfig | null;
  }
}

// To fix
// TS1219 TypeScript(TS) Experimental support for decorators is a feature that is subject to
// change in a future release.Set the 'experimentalDecorators' option to remove this warning.
// Change the "Build Action" on camn\CamnClient\ClientApp\tsconfig.json from None to Content per
// https://github.com/Microsoft/TypeScript/issues/25823
@Injectable()
export class ConfigService {
  constructor(private appConfig: AppConfig) { }

  get defaultPath(): string { return this.appConfig.defaultPath; }

  get webApiEndpoint(): string {
    return '';
  }

  get loggingOption(): LoggerOptions { return this.appConfig.loggingOption; }
}

export function configServiceFactory(): () => ConfigService {
  return () => new ConfigService(window['appConfig']!);
}
